import { Lock } from "lucide-react";
import { Reveal } from "./shared";
import { track } from "../../lib/analytics";

export const PrivacyBand = () => (
  <section className="py-14 sm:py-20 bg-[#0B0B0C] border-y border-[#F2F0EB]/5" data-testid="privacy-band-section">
    <Reveal className="mx-auto max-w-3xl px-5 sm:px-8 text-center">
      <Lock size={18} className="mx-auto text-[#FF4D0A] mb-5" />
      <h3 className="font-display font-bold text-2xl sm:text-3xl mb-4" data-testid="privacy-band-headline">
        Private by design.
      </h3>
      <p className="text-[#9DA1A8] leading-relaxed" data-testid="privacy-band-body">
        Your profile is computed on device. Birth data never leaves the app.
        The people you add are never notified.
      </p>
      <a
        href="#secure"
        onClick={() => track("cta_create_source_code", { location: "privacy_band" })}
        className="mt-8 sm:mt-10 inline-block bg-[#FF4D0A] text-[#0B0B0C] font-display font-bold text-[13px] sm:text-sm tracking-wide uppercase px-8 py-4 hover:brightness-110 transition"
        data-testid="privacy-band-cta-link"
      >
        Get my code
      </a>
    </Reveal>
  </section>
);
